import SpotlightModal from '../controls/spotlight/SpotlightModal'
import BaseLayout from '../layout/BaseLayout'
import ModalService from '../services/ModalService'
import PiPService from '../services/PiPService'
import SessionExpiredService from '../services/SessionExpiredService'
import SnackbarService from '../services/SnackbarService'

function AppInitializer() {
    return (
        <>
            <BaseLayout />
            <SpotlightModal />
            <ModalService />
            <SnackbarService />
            <PiPService />
            <SessionExpiredService />
        </>
    )
}

export default AppInitializer
